import type { Product } from "src/api/client-api/products/useGetOneProduct";

type SpaceProduct = Pick<Product, "ownedBy" | "shares">;

const isOwner = (product: SpaceProduct, companyId: number | undefined): boolean =>
    companyId !== undefined && product.ownedBy?.id === companyId;

const isShare = (product: SpaceProduct, companyId: number | undefined): boolean =>
    companyId !== undefined && (product.shares ?? []).some((share) => share.organization.id === companyId);

export const hasActivityDataSpace = (product: SpaceProduct | undefined, companyId: number | undefined): boolean => {
    if (product === undefined || (product.shares ?? []).length === 0) return false;

    return isOwner(product, companyId) || isShare(product, companyId);
};

export const isCompanyOutsideProduct = (product: SpaceProduct | undefined, companyId: number | undefined): boolean => {
    if (product === undefined || product.ownedBy === undefined || product.ownedBy === null) return false;

    return !isOwner(product, companyId) && !isShare(product, companyId);
};
